export default __webpack_public_path__ + "static/media/WinterClothes_00.5047df98.png";